import TintingTemplate from './TintingTemplate'

export * from './TintingTemplate'

export default TintingTemplate
